export default "__VITE_ASSET__uyGy$CJG__"